var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.75,
    height: 23.813,
    viewBox: "0 0 31.75 23.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_163",
    "data-name": "Trac\\xE9 163",
    d: "M0,5.969A3.969,3.969,0,0,1,3.969,2H27.781A3.969,3.969,0,0,1,31.75,5.969V21.844a3.969,3.969,0,0,1-3.969,3.969H3.969A3.969,3.969,0,0,1,0,21.844ZM3.969,3.984A1.984,1.984,0,0,0,1.984,5.969V6.4l13.891,8.334L29.766,6.4V5.969a1.984,1.984,0,0,0-1.984-1.984Zm25.8,4.729-9.342,5.606,9.342,5.749ZM29.7,22.358,18.506,15.47l-2.631,1.578L13.244,15.47,2.052,22.356a1.984,1.984,0,0,0,1.917,1.472H27.781A1.984,1.984,0,0,0,29.7,22.357ZM1.984,20.068l9.342-5.749L1.984,8.713Z",
    transform: "translate(0 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.978abe6a4a26b654e839deae9fa0bdc0.svg";
export { ForwardRef as ReactComponent };